define(["require", "exports", "jquery", "knockout", "../../utils/tools", "../../models/UserContext", "../../models/TagModel", "../../utils/LookupDataSources"], function (require, exports, $, ko, tools, UserContext, TagModel, LookupDataSources) {
    "use strict";
    var CustomerTags = /** @class */ (function () {
        function CustomerTags(customerId) {
            this.userCanViewTags = ko.observable(UserContext.hasAccess("Admin,CustomerTag.View,CustomerTag.Edit,CustomerTag.Delete"));
            this.userCanEditTags = ko.observable(UserContext.hasAccess("Admin,CustomerTag.Edit,CustomerTag.Delete"));
            this.userCanDeleteTags = ko.observable(UserContext.hasAccess("Admin,CustomerTag.Delete"));
            this.customerId = ko.observable(0);
            this.tagList = ko.observableArray([]);
            this.editModel = ko.observable(new TagModel());
            var self = this;
            self.customerId(customerId);
            if (self.userCanViewTags()) {
                self.initCustomerTags();
            }
        }
        CustomerTags.prototype.initCustomerTags = function () {
            var self = this;
            $("#divCustomerTagHolder").html("<div data-bind=\"template: { name: 'tags-list-template', data: $root.customerTags }\"></div>");
            self.getCustomerTags();
        };
        CustomerTags.prototype.getCustomerTags = function () {
            var self = this;
            tools.ajaxGet({
                url: "/CustomerTags/GetCustomerTags?id=" + self.customerId()
            }).done(function (result) {
                if (result.Data) {
                    ko.mapping.fromJS(result.Data, {}, self.tagList);
                }
            }).always(function () {
            });
        };
        CustomerTags.prototype.addCustomerTag = function () {
            var self = this;
            var title = "Add Tag";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    if (!self.employeesDropdown.value()) {
                        tools.error("Tag is a required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCustomerTag(event.currentTarget, modal, self.employeesDropdown.value());
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'tag-add-template', data: $root.customerTags }\"></div>");
                    ko.applyBindings(self, modal);
                    var lookupDataSources = new LookupDataSources();
                    var tagsDS = lookupDataSources.createLookupDataSource("Tags");
                    self.employeesDropdown = $("input[name=TagId]", modal).kendoDropDownList({
                        dataSource: tagsDS,
                        dataTextField: "Text",
                        dataValueField: "Id",
                        valuePrimitive: true,
                        filter: "contains",
                        popup: {
                            appendTo: $(".modal-body", modal)
                        }
                    }).data("kendoDropDownList");
                }
            });
        };
        CustomerTags.prototype.saveCustomerTag = function (btn, modal, tagId) {
            var self = this;
            var obj = {
                customerId: self.customerId(),
                tagId: tagId
            };
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerTags/AddCustomerTag",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.getCustomerTags();
                    $(modal).modal("hide");
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerTags.prototype.deleteTagConfirm = function (tag) {
            var self = this;
            tools.confirmModal({
                title: "Delete Customer Tag",
                text: "Are you sure you want to delete Customer Tag?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCustomerTag(tag.Id);
            });
        };
        CustomerTags.prototype.deleteCustomerTag = function (tagId) {
            var self = this;
            var data = {
                customerId: self.customerId(),
                tagId: tagId
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerTags/DeleteCustomerTagConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Customer Tag deleted successfully");
                    self.getCustomerTags();
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        return CustomerTags;
    }());
    return CustomerTags;
});
//# sourceMappingURL=customerTags.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerTags.js
// module id = 171
// module chunks = 2